import { useEffect } from 'react';

/**
 * Show the browser's "leave site?" prompt when the user tries to close the tab
 * or hit refresh while there's unsaved work. The browser overrides the message
 * text in modern Chromium/Firefox/Safari, but ANY non-empty returnValue
 * triggers the prompt.
 *
 * Usage: useUnsavedGuard(hasUnsaved);
 */
export function useUnsavedGuard(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const handler = (e: BeforeUnloadEvent): string => {
      e.preventDefault();
      // returnValue is required for the prompt to show.
      e.returnValue = '';
      return '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [active]);
}
